import { Component, OnInit, Input } from '@angular/core';
import { AlgConsensoService } from '../../../services/alg-consenso.service';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

@Component({
  selector: 'alg-consenso-contract-hero',
  templateUrl: './alg-consenso-contract-hero.component.html',
  styleUrls: ['./alg-consenso-contract-hero.component.scss'],
})
export class AlgConsensoContractHeroComponent {
  @Input() reverse: boolean;
  @Input() firstStep: boolean;
  @Input() isProductGasVulnerable: boolean;

  public productName$: Observable<string>;
  public productVulnerable: boolean;
  constructor(private consensoService: AlgConsensoService) {
    this.productName$ = this.consensoService.approvalProduct$.pipe(
      map((product) => {
        if (product.duration !== 'N/A') {
          return (
            !!product &&
            `${product.family || ''} ${product.type || ''} ${
              product.duration || ''
            } ${product.lightRate || ''}`
          );
        }
        if (product.duration === 'N/A') {
          return (
            !!product &&
            `${product.family || ''} ${product.type || ''} ${
              product.lightRate || ''
            }`
          );
        }
      })
    );
  }

  ngOnChanges() {
    this.productVulnerable = this.isProductGasVulnerable
  }
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-consenso-contract-hero/alg-consenso-contract-hero.component.ts